import { PhoneNumberUtil } from 'google-libphonenumber';

export const TESTING_NUMBERS = [
    '+420 888999000',
    '+420 888999001',
    '+420 888999002',
    '+420 888999003',
    '+420 888999004',
    '+420 888999005',
    '+420 888999006',
    '+420 888999007',
    '+420 888999008',
    '+420 888999009',
    '+420 888999010',
    '+420 888999011',
    '+420 888999012',
    '+420 888999013',
    '+420 888999014',
    '+420 888999015',
    '+420 888999016',
    '+420 888999017',
    '+420 888999018',
    '+420 888999019',
    '+420 888999100',
    '+420 888999101',
    '+420 888999102',
    '+420 888999103',
    '+420 888999104',
    '+420 888999105',
    '+420 888999106',
    '+420 888999107',
    '+420 888999108',
    '+420 888999109',
    '+420 888999110',
    '+420 888999111',
    '+420 888999112',
    '+420 888999113',
    '+420 888999114',
    '+420 888999115',
    '+420 888999116',
    '+420 888999117',
    '+420 888999118',
    '+420 888999119',
];

export const isVideoUrl = (url: string) => {
    try {
        return /\.(mp4|webm|ogg)$/i.test(new URL(url).pathname);
    } catch {
        return /\.(mp4|webm|ogg)(\?.*)?$/i.test(url);
    }
};
export const isEmailValid = (text: string) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/u.test(text);

const phoneUtil = PhoneNumberUtil.getInstance();

export const isTelephoneValid = (text: string, includeTestingNumbers = true) => {
    if (includeTestingNumbers && TESTING_NUMBERS.includes(text)) {
        return true;
    }
    try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(text));
    } catch {
        return false;
    }
};
